export enum LocalStorageKey {
  USER_TOKEN = 'userToken',
  PROFILE = 'profile',
}
